import { createStore } from 'owa-satcheljs';

export interface StaleFlightUpdateState {
    isUpdateAvailable: boolean;
    isApplyingUpdate: boolean;
    enabledChangeCount: number;
    disabledChangeCount: number;
    detectedAt: number;
}

const getStaleFlightUpdateStore: () => StaleFlightUpdateState = createStore<StaleFlightUpdateState>(
    'staleFlightUpdate',
    {
        isUpdateAvailable: false,
        isApplyingUpdate: false,
        enabledChangeCount: 0,
        disabledChangeCount: 0,
        detectedAt: 0,
    }
);

export default getStaleFlightUpdateStore;
